import * as React from "react";
import { Divider, Spin, Typography } from "antd";
import { IIndexesByOrganisationDataReportPresenter } from "../../presenter/IndexesByOrganisationDataReportPresenter";
import IndexesByCategoryDataParamBox from "../components/IndexesByCategoryDataParamBox";
import { FileExcelOutlined } from "@ant-design/icons";
import PDFExportIndexesByCategoryDataReport from "../components/PDFExportIndexesByCategoryDataReport";
import IndexHarmonizationReportPreview from "../components/IndexHarmonizationReportPreview";

export interface Props {}

export interface State extends IIndexesByOrganisationDataReportPresenter {}

export default class IndexesByCategoryDataPage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      translate,
      organisationIndexCategories,
      organisations,
      setOrganisationId,
      organisationId,
      getData,
      data,
      setCategoryId,
      selectedCategoryId
    } = this.state;

    const organisation = organisations.find(
      (item) => item.id === organisationId
    );
    return (
      <Spin spinning={this.state.loaders.projectLoader}>
        <div style={{ display: "flex", flexDirection: "row", height: "100%" }}>
          <IndexesByCategoryDataParamBox
            getData={getData}
            organisationId={organisationId}
            organisationIndexCategories={organisationIndexCategories}
            organisations={organisations}
            selectedCategoryId={selectedCategoryId}
            setCategoryId={setCategoryId}
            setOrganisationId={setOrganisationId}
            translate={translate}
          />
          <Divider type={"vertical"} style={{ height: "100%" }} />
          {
            <div style={{ width: "75%", paddingLeft: 10 }}>
              <div>
                <Typography.Title style={{ fontSize: 20 }}>
                  {translate("reports.indexes_by_category_data_report")}
                </Typography.Title>
              </div>

              <Spin spinning={this.state.loaders.reportLoader}>
                {data && data.length > 0 && (
                  <div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        float: "right",
                        marginBottom: 20
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          textAlign: "right"
                        }}
                      >
                        <PDFExportIndexesByCategoryDataReport
                          translate={translate}
                          data={data}
                          fileName={`${translate(
                            "reports.indexes_by_category_data_report"
                          )} za organizaciju ${organisation?.name}`}
                          selectedCategory={organisationIndexCategories.find(
                            (item) => item.id === selectedCategoryId
                          )}
                        />
                        <Divider
                          type={"vertical"}
                          style={{ fontSize: 10, height: "100%" }}
                        />
                        <a
                          key="file-excel"
                          rel="noopener noreferrer"
                          href={`/api/reports/indexes-by-category/xlsx?organisationId=${organisationId}&organisationIndexCategoryId=${selectedCategoryId}`}
                          target="_blank"
                        >
                          <FileExcelOutlined
                            style={{ fontSize: 20, color: "#20744B" }}
                          />
                        </a>
                      </div>
                    </div>

                    <IndexHarmonizationReportPreview
                      translate={translate}
                      organisations={organisations}
                      data={data}
                      title={translate(
                        "reports.non_harmonised_index_data_report"
                      )}
                      loader={this.state.loaders.report1Loader}
                      selectedCategory={organisationIndexCategories.find(
                        (item) => item.id === selectedCategoryId
                      )}
                    />
                  </div>
                )}
              </Spin>
            </div>
          }
        </div>
      </Spin>
    );
  }
}
